function collectionColourSwatchDropdown() {
  //Toggle select box
  $(".colourSwatches .styledSelect").click(function() {
    $(this).addClass("hidden");
    $(".colourSwatches .select ul, .colourSwatches .select li").removeClass("hidden").addClass("active");
  });
  
  $(document.body).click(function(event) {
      var target = $( event.target );
      if ( target.is( ".colourSwatches .styledSelect")) {
      } else {
        $(".colourSwatches .styledSelect").removeClass("hidden");
    	$(".colourSwatches .select ul, .colourSwatches .select li").removeClass("active").addClass("hidden");
      } 
  });
}

function patternVariantSelected() {
  //onload
  var loadingVariant = ($('#variant').data('variant'));
  if (loadingVariant == 'ORAJET 3651' || loadingVariant == 'Siser HTV') {
      if (loadingVariant == 'Siser HTV') {
         $("#SingleOptionSelector-2").parent().css("display", "block");
      } else {
         $("#SingleOptionSelector-2").parent().css("display", "none");
      }
  }
  
  
  //onchange
  $("#SingleOptionSelector-0").change(function () {
    if($(this).val() == "ORAJET 3651" || $(this).val() == "Siser HTV") {
      if($(this).val() == "Siser HTV") {
        $("#SingleOptionSelector-2").parent().css("display", "block");
      } else {
        $("#SingleOptionSelector-2").parent().css("display", "none");
      }
    }
  });
}

$(function() {
  collectionColourSwatchDropdown();
  patternVariantSelected();
});

function bundle() {	
  var patternMaterialSelected = $("#SingleOptionSelector-0").val();
  var TTDMaskSelected = $("#SingleOptionSelector-2").val();
  if (patternMaterialSelected == "Siser HTV" && TTDMaskSelected == "Yes (+$1.59)") {
//Ajax request to add special item to cart
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
  			quantity: $(".patternQuantity input").val(),
  			id: 33196282445912
		},
      async: false
    })
  }
};